import './AccountApp.less';
import React, {useState, useContext} from 'react';
import AuthContext from "../../contexts/auth/AuthContext";
import __ from "../../i18n";
import ImagePicker from "../../widgets/image-picker/ImagePicker";
import Request from "../../../bootstrap/api/Request";
import AccountUpdateInfoParcel from "../../api/endpoints/account/AccountUpdateInfoParcel";
import Toasts, {TOAST_ERROR, TOAST_SUCCESS} from "../../../bootstrap/scomponents/toasts/Toasts";
import Popup from "../../../bootstrap/components/popup/Popup";
import UserAvatar from "../../widgets/user-avatar/UserAvatar";
import Icon from "../../../bootstrap/components/icon/Icon";
import InfoEditor from "./info-editor/InfoEditor";
import AccountUpdatePasswordParcel from "../../api/endpoints/account/AccountUpdatePasswordParcel";
import DraftView from '../../components/draft-view/DraftView';
import {jsonToObject} from '../../../bootstrap/utils/json';


export default function AccountApp() {

    const {user, avatarImage, patchInfo, logout} = useContext(AuthContext);

    const [editorName, setEditorName] = useState(null);

    const requestUpdateInfo = (values, onSuccess, onError) => {
        Request.add(new AccountUpdateInfoParcel(values))
            .then(() => {
                Toasts.add(TOAST_SUCCESS, __('Your changes has been saved successfully'));
                onSuccess();
            })
            .catch(error => {
                onError(error.getMessage());
            });
    }

    const requestUpdatePassword = (values, onSuccess, onError) => {
        Request.add(new AccountUpdatePasswordParcel(values))
            .then(() => {
                Toasts.add(TOAST_SUCCESS, __('Your changes has been saved successfully'));
                onSuccess();
            })
            .catch(error => {
                onError(error.getMessage());
            });
    }

    return <div className="account-app">
        <div className="inner">
            <div className="avatar-row">
                <div className="avatar-view" onClick={() => setEditorName('avatarImage')}>
                    <UserAvatar image={avatarImage}/>
                    <div className="edit-indicator">
                        <Icon name="camera"/>
                    </div>
                </div>
            </div>
            <div className="headline">
                <h1 className="user-name">{__('Welcome, ::user', {user: user.full_name})}</h1>
                <div className="description">{__('Manage your personal info, email and password')}</div>
            </div>
            <div className="table-wrapper">
                <table>
                    <tbody>
                    <tr>
                        <th>{__('Full name')}</th>
                        <td>{user.full_name}</td>
                        <td>
                            <button
                                type="button"
                                className="edit-button"
                                onClick={() => setEditorName('fullName')}
                            >
                                <Icon name="pencil"/>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th>{__('Title')}</th>
                        <td>{user.title}</td>
                        <td>
                            <button
                                type="button"
                                className="edit-button"
                                onClick={() => setEditorName('title')}
                            >
                                <Icon name="pencil"/>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th>{__('Email')}</th>
                        <td>{user.email}</td>
                        <td>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <th>{__('Phone')}</th>
                        <td>{user.phone}</td>
                        <td>
                            <button
                                type="button"
                                className="edit-button"
                                onClick={() => setEditorName('phone')}
                            >
                                <Icon name="pencil"/>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th>{__('Introduction')}</th>
                        <td>
                            {
                                user.introduction !== null ?
                                <DraftView contentState={jsonToObject(user.introduction)} /> :
                                <i>{__('Help people know more about you')}</i>
                            }
                        </td>
                        <td>
                            <button
                                type="button"
                                className="edit-button"
                                onClick={() => setEditorName('introduction')}
                            >
                                <Icon name="pencil"/>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th>{__('Password')}</th>
                        <td>&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;</td>
                        <td>
                            <button
                                type="button"
                                className="edit-button"
                                onClick={() => setEditorName('password')}
                            >
                                <Icon name="pencil"/>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        {
            editorName === 'avatarImage' &&
            <Popup name="account-app">
                <ImagePicker
                    maxFiles={1}
                    onDone={([image]) => {
                        setEditorName(null);
                        requestUpdateInfo({avatar_image_id: image.id}, () => {
                            patchInfo({avatarImage: image});
                        }, (errorMessage) => {
                            Toasts.add(TOAST_ERROR, errorMessage);
                        });
                    }}
                    onCancel={() => setEditorName(null)}
                />
            </Popup>
        }
        {
            editorName === 'fullName' &&
            <Popup name="account-app">
                <InfoEditor
                    layoutConfig={['full_name']}
                    requestUpdate={requestUpdateInfo}
                    onDone={() => {
                        setEditorName(null);
                    }}
                    onCancel={() => {
                        setEditorName(null);
                    }}
                />
            </Popup>
        }
        {
            editorName === 'title' &&
            <Popup name="account-app">
                <InfoEditor
                    layoutConfig={['title']}
                    requestUpdate={requestUpdateInfo}
                    onDone={() => {
                        setEditorName(null);
                    }}
                    onCancel={() => {
                        setEditorName(null);
                    }}
                />
            </Popup>
        }
        {
            editorName === 'email' &&
            <Popup name="account-app">
                <InfoEditor
                    layoutConfig={['email']}
                    requestUpdate={requestUpdateInfo}
                    onDone={() => {
                        setEditorName(null);
                        logout();
                    }}
                    onCancel={() => {
                        setEditorName(null);
                    }}
                    notice={__('You will be logged out after changing email')}
                />
            </Popup>
        }
        {
            editorName === 'phone' &&
            <Popup name="account-app">
                <InfoEditor
                    layoutConfig={['phone']}
                    requestUpdate={requestUpdateInfo}
                    onDone={() => {
                        setEditorName(null);
                    }}
                    onCancel={() => {
                        setEditorName(null);
                    }}
                />
            </Popup>
        }
        {
            editorName === 'introduction' &&
            <Popup name="account-app">
                <InfoEditor
                    layoutConfig={['introduction']}
                    requestUpdate={requestUpdateInfo}
                    onDone={() => {
                        setEditorName(null);
                    }}
                    onCancel={() => {
                        setEditorName(null);
                    }}
                />
            </Popup>
        }
        {
            editorName === 'password' &&
            <Popup name="account-app">
                <InfoEditor
                    layoutConfig={['password', 'new_password']}
                    requestUpdate={requestUpdatePassword}
                    onDone={() => {
                        setEditorName(null);
                        logout();
                    }}
                    onCancel={() => {
                        setEditorName(null);
                    }}
                    notice={__('You will be logged out after changing password')}
                />
            </Popup>
        }
    </div>;
}
